<template>
    <v-list-item-group class="pb-5">
        <v-list-item v-for="(item) in subcategories" :key="item.id" link :to="item.path">
            <v-list-item-content>
                <v-list-item-title v-text="item.localName"></v-list-item-title>
            </v-list-item-content>
            <v-list-item-icon>
                <v-list-item-title v-text="item.count"></v-list-item-title>
            </v-list-item-icon>
        </v-list-item >
    </v-list-item-group>
</template>

<script>
    export default {
        name: "Subcategories",
        props: ['subcategories'],
        data() {
            return {

            }
        },
        methods: {}
    }
</script>

<style scoped>

</style>
